<template>
    <footer class="p-4 flex-shrink-0">
        <v-flex align="center" justify="center">
            <slot name="content"></slot>
            <div :class="[color, 'flex-fill text-right']">
                <small class="text-muted d-none d-md-inline" v-if="powered">POWERED BY</small>
                <a :class="[color, 'ml-2 logo']" aria-label="Ladder Home" href="https://joinladder.com">
                    <Wordmark />
                </a>
            </div>
        </v-flex>
    </footer>
</template>

<script>
import Wordmark from "@/components/Wordmark";

export default {
    name: "LadderFooter",
    components: {
        Wordmark
    },
    props: {
        dark: { type: Boolean },
        powered: { type: Boolean, default: true }
    },
    computed: {
        color() {
            return this.dark ? "text-light" : "text-dark";
        }
    }
};
</script>

<style scoped lang="scss">
.logo:hover {
    color: $primary !important;
}
.ladder-powered:hover {
    color: $primary !important;
}
</style>